/**
 * @fileoverview PropertyHeaderCard constants
 * @module PropertyHeaderCard/constants
 * SECURITY: Immutable config only; no user input.
 * DESIGN: sx/theme only; no CSS classes. Badge colors via theme (primary, success, warning, error).
 */

import { alpha } from '@mui/material/styles';

/** Fit score display values */
export const FIT_SCORES = Object.freeze(['STRONG FIT', 'GOOD FIT', 'WEAK FIT']);

/**
 * Fit score badge sx builder (theme-based). Use in sx={(theme) => ({ ...getFitScoreBadgeSx(theme)[fitScore] })}
 * @param {import('@mui/material/styles').Theme} theme
 * @returns {Record<string, object>}
 */
export function getFitScoreBadgeSx(theme) {
  return {
    'STRONG FIT': {
      bgcolor: '#D9EAE0',
      color: 'success.main',
    },
    'GOOD FIT': {
      bgcolor: theme.palette.warning?.light ?? alpha(theme.palette.warning.main, 0.2),
      color: 'warning.main',
    },
    'WEAK FIT': {
      bgcolor: theme.palette.error?.light ?? alpha(theme.palette.error.main, 0.2),
      color: 'error.main',
    },
  };
}

/** Default price when missing or invalid */
export const FALLBACK_PRICE_LABEL = '$0';

/** Default address when missing */
export const FALLBACK_ADDRESS = 'Address hidden';

/** Aria label for Zillow badge */
export const ZILLOW_BADGE_ARIA_LABEL = 'Zillow data available';

/** Zillow badge blue when theme.palette.zillow is not set */
export const ZILLOW_BLUE_FALLBACK = '#6BB3F0';

/** Gradient end color for price text (sunset peach) when not in theme */
export const PRICE_GRADIENT_END_FALLBACK = '#E7AD87';
